import React from 'react';

/**
 * PageContainer — consistent page-level layout wrapper.
 * Matches the Dashboard's max-width, padding, and vertical section spacing.
 */
export const PageContainer = ({ children, className = '' }) => (
  <div
    className={[
      'px-5 py-5 sm:px-6 xl:px-[26px]',
      'page-column',
      'flex flex-col gap-[18px]',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {children}
    {/* bottom breathing room */}
    <div aria-hidden="true" style={{ height: '16px' }} />
  </div>
);
